import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=8a30c79e&"
import script from "./PageHeader.vue?vue&type=script&lang=coffee&"
export * from "./PageHeader.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports